// extracted by mini-css-extract-plugin
export default {"container":"responsiveGrid_container__NprkZ"};